export enum SynapiItemTypes{
  ACTIVITE = "ACTIVITE",
  COMMERCE_ET_SERVICE = "COMMERCE_ET_SERVICE",
  DEGUSTATION = "DEGUSTATION",
  DOMAINE_SKIABLE = "DOMAINE_SKIABLE",
  EQUIPEMENT = "EQUIPEMENT",
  FETE_ET_MANIFESTATION = "FETE_ET_MANIFESTATION",
  HEBERGEMENT_COLLECTIF = "HEBERGEMENT_COLLECTIF",
  HEBERGEMENT_LOCATIF = "HEBERGEMENT_LOCATIF",
  HOTELLERIE = "HOTELLERIE",
  HOTELLERIE_PLEIN_AIR = "HOTELLERIE_PLEIN_AIR",
  PATRIMOINE_CULTUREL = "PATRIMOINE_CULTUREL",
  PATRIMOINE_NATUREL = "PATRIMOINE_NATUREL",
  RESTAURATION = "RESTAURATION",
  SEJOUR_PACKAGE = "SEJOUR_PACKAGE",
  STRUCTURE = "STRUCTURE",
  TERRITOIRE = "TERRITOIRE"
}
